module.exports = __webpack_public_path__ + "static/media/status_error_flipped.c09973d9.svg";